import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/ForgotPassword.css";
import { FaChevronLeft } from "react-icons/fa";
import HeaderLogo from "../components/HeaderLogo";
import ApiService from "../services/api";

function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [errors, setErrors] = useState({});
  const [isLoading, setIsLoading] = useState(false);

 
  useEffect(() => {
    localStorage.removeItem('reset_email');
    localStorage.removeItem('otp_verified');

    const handleBeforeUnload = () => {
      localStorage.removeItem('reset_email');
      localStorage.removeItem('otp_verified');
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, []);

  const validateForm = () => {
    const newErrors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!email) {
      newErrors.email = "Email is required";
    } else if (!emailRegex.test(email)) {
      newErrors.email = "Enter a valid email";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) return;

    setIsLoading(true);
    setErrors({});

    try {
      const response = await ApiService.forgotPassword(email);
      
      // Store email for use in subsequent steps
      localStorage.setItem('reset_email', email);
      
      // Navigate to OTP verification page
      navigate("/email-verify", { 
        state: { 
          email: email,
          purpose: 'password_reset',
          message: response.message 
        }
      });
    } catch (error) {
      setErrors({ 
        general: error.message || "Failed to send verification code. Please try again." 
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="forgot-container">
      <HeaderLogo />

      <div className="forgot-card">
        <div className="forgot-back" onClick={() => navigate("/")}>
          <FaChevronLeft className="back-icon" />
          <span className="back-text">Back</span>
        </div>

        <h2 className="forgot-heading">Send Verification Code</h2>
        <p className="forgot-subtext">
          Please enter your email address to receive your verification code
        </p>

        {errors.general && (
          <p className="forgot-error forgot-general-error">{errors.general}</p>
        )}

        <form onSubmit={handleSubmit} className="forgot-form">
          <div className="forgot-input-wrapper">
            <label>Email</label>
            <input
              type="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              disabled={isLoading}
             maxLength={255} />
            <p className="forgot-error">{errors.email || " "}</p>
          </div>

          <button 
            type="submit" 
            className="forgot-sent-btn"
            disabled={isLoading}
          >
            {isLoading ? "Sending..." : "Send"}
          </button>
        </form>
      </div>
    </div>
  );
}

export default ForgotPassword;
